import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const BannerContainer = superstyled({
  tag: Card,
  name: 'PromotionalBanner',
  slot: 'BannerContainer',
  styles: () => ({
    padding: '1rem',
    marginTop: '1.5rem',
    marginBottom: 0,
  }),
});

export const BannerTitle = superstyled({
  tag: Text,
  name: 'PromotionalBanner',
  slot: 'BannerTitle',
  styles: () => ({
    marginBottom: '0.5rem',
  }),
});

export const BannerDescription = superstyled({
  tag: Text,
  name: 'PromotionalBanner',
  slot: 'BannerDescription',
  styles: () => ({
    lineHeight: 1.5,
  }),
});

export const StyledButton = superstyled({
  tag: Button,
  name: 'PromotionalBanner',
  slot: 'StyledButton',
  styles: () => ({
    marginTop: '1rem',
  }),
});

BannerContainer.defaultProps = {
  color: 'black',
};

BannerTitle.defaultProps = {
  component: 'p',
  size: 'md',
  weight: 'medium',
  color: 'white',
};

BannerDescription.defaultProps = {
  component: 'p',
  size: 'xs',
  color: 'white',
};

StyledButton.defaultProps = {
  size: 'sm',
  color: 'secondary',
  fullWidth: true,
};
